import { Link } from "@/components/common/Link";
export default function FooterArchive() {
  const currentYear = new Date().getFullYear();
  const quickLinks = [{
    label: "The Archives",
    to: "/TheArchivesPage"
  }, {
    label: "The Artist",
    to: "/TheArtistPage"
  }, {
    label: "Technical Notes",
    to: "/TechnicalNotesPage"
  }];
  const socialLinks = [{
    label: "Instagram",
    to: "https://instagram.com"
  }, {
    label: "Vimeo",
    to: "https://vimeo.com"
  }, {
    label: "Are.na",
    to: "https://are.na"
  }];
  return <section id="footer-archive" className="dark bg-background bg-black text-foreground font-mono text-[12px] border-t border-white/15">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit opacity-90 hover:opacity-100 transition-opacity">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/filmframe_logo_white.png" alt="FilmFrame" className="h-7 w-auto" />
            </Link>
            <p className="leading-relaxed max-w-xs text-muted-foreground">
              FilmFrame is a film photography portfolio website showcasing the timeless art of analog imaging.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white uppercase tracking-wider font-medium">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              {quickLinks.map((link, i) => <Link key={i} to={link.to} className="text-muted-foreground hover:text-white transition-colors w-fit" data-index={i}>
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white uppercase tracking-wider font-medium">Social</h3>
            <nav className="flex flex-col gap-3">
              {socialLinks.map((link, i) => <Link key={i} to={link.to} newTab className="text-muted-foreground hover:text-white transition-colors w-fit" data-index={i}>
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6 md:justify-between h-full">
            <div className="flex flex-col gap-1">
              <h3 className="text-white uppercase tracking-wider font-medium">Legal</h3>
              <p className="text-muted-foreground">© {currentYear} FilmFrame</p>
            </div>
            <p className="text-zinc-600 pt-4 md:pt-0">
              Developed in the Darkroom
            </p>
          </div>
        </div>
      </div>
    </section>;
}